import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function fmtErr(e, fallback = "Something went wrong. Please try again.") {
    const d = e?.response?.data?.detail;
    if (d == null) return e?.message || fallback;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
    if (typeof d?.msg === "string") return d.msg;
    return String(d);
}

export async function downloadPdf(url, filename, token) {
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const res = await axios.get(`${API}${url}`, {
        responseType: "blob",
        withCredentials: !token,
        headers,
    });
    const blobUrl = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(blobUrl);
}
